import React from "react";
import { Modal, Checkbox, Typography, Alert } from "antd";

const RecordingConsentModal = ({
  open,
  checked,
  onCheck,
  onOk,
  onCancel,
  transcriptExists,
}) => {
  const [isProcessing, setIsProcessing] = React.useState(false);

  const handleOk = async () => {
    setIsProcessing(true);
    try {
      await onOk();
    } finally {
      // Reset after a delay to prevent rapid re-opening
      setTimeout(() => setIsProcessing(false), 500);
    }
  };

  const handleCancel = () => {
    setIsProcessing(false);
    onCancel();
  };

  return (
    <Modal
      title="Consent to Audio Recording"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={isProcessing ? "Starting..." : "I Agree & Continue"}
      okButtonProps={{ 
        disabled: (transcriptExists && !checked) || isProcessing,
        loading: isProcessing,
      }}
      cancelButtonProps={{
        disabled: isProcessing,
      }}
      maskClosable={false}
      closable={!isProcessing}
      destroyOnClose
      centered
    >
      {transcriptExists && (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 12 }}
          message="Warning: Starting a new recording or uploading a new transcript will delete the current transcript. Do you still wish to proceed?"
        />
      )}

      <Typography.Paragraph style={{ marginBottom: 12 }}>
        To proceed with voice features, I confirm that all required consent has
        been obtained to capture and process audio. The audio will be
        transmitted securely to our speech service for real-time transcription.
      </Typography.Paragraph>

      <Checkbox 
        checked={checked} 
        onChange={(e) => onCheck(e.target.checked)}
        disabled={isProcessing}
      >
        {transcriptExists ? (
          <>I attest that I have obtained all required consent for audio recording in this session.</>
        ) : (
          <>I consent to audio recording for this session.</>
        )}
      </Checkbox>
    </Modal>
  );
};

export default RecordingConsentModal;
